import { mutator } from 'satcheljs';
import { dismissItem } from '../actions/dismissItem';
import { dismissAllItems } from '../actions/dismissAllItems';
import { getActivityFeedStore } from '../store/store';

mutator(dismissItem, ({ itemId }) => {
    getActivityFeedStore().items.delete(itemId);
});

mutator(dismissAllItems, () => {
    getActivityFeedStore().items.clear();
});
